import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFile, faFolder, faTrash, faEye, faHistory, faList } from "@fortawesome/free-solid-svg-icons";
import { Progress } from "reactstrap";
import ReactTooltip from 'react-tooltip';
import './index.scss';
import { processes } from "../../../utils/constants";
import { dateFormat } from "../../../utils/common";
import _ from 'underscore';
import TimezoneClock from "../../../components/common/TimeZone";
import { useSelector } from "react-redux";
import Item from "../../../components/Header/NotificationDropdown/Item";

const UploadedFileItem = ({ className = '', queue, _deleteQueue, _viewDocuments, _viewLoans, _downloadFile, queueId, _viewDocumentLogs, checkedItems, handleCheckboxChange }) => {
	const userDetail = useSelector((state) => state?.user?.user);
	const [timeDifference, setTimeDifference] = useState(0);

    useEffect(() => {
        if (queue?.createdAt) {
            const timeNow = new Date();
            const createdAt = new Date(queue.createdAt);
            const difference = timeNow - createdAt;
            setTimeDifference(difference);
        }
    }, [queue?.createdAt]);




	let loan_numbers = '';
	if (queue?.documentIds && queue?.documentIds.length) {
		console.log('queue.documentIds', queue?.documentIds.length)
		loan_numbers = _.uniq(queue.documentIds.map(x => x?.loan_number)).join(" ")
	}

	return (
		<>
			<ul className={`uploaded-file-blc list-unstyled ${className}`}>
			
				<li style={{ backgroundColor: queueId === queue?._id ? "#c1ccd7" : '' }}>
					<div className="head-blc d-flex align-items-center">

					
						<label className="d-flex flex-column">
							<span className="txt-cell">
					            {queue.ml_response_error && 
									<input type="checkbox"   
									checked={checkedItems.includes(queue?._id)}
									onChange={() => handleCheckboxChange(queue?._id)} /> 
								} 
								
								<strong>Loan No.  </strong>
								{queue?.file_type == 'zip' ? <><span id="viewLoans">
									<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faEye} data-tip={'View loan numbers'} onClick={() => _viewLoans(queue)} />
								</span> <ReactTooltip /> </> : loan_numbers}
								<ReactTooltip />
							</span>
							<span className="txt-cell" data-tip={queue?.name}>
								{queue?.name}
							</span>
							<span className="date-cell">
								{/* {queue?.createdAt && dateFormat(queue.createdAt)} */}
								{(userDetail?.timezone && queue?.createdAt) ? <TimezoneClock timezone={userDetail?.timezone} dateTime={queue.createdAt} timeFormat={"MMMM Do YYYY, h:mm a"} /> : dateFormat(queue.createdAt)}
							</span>
						</label>

						<div className="right-col d-inline-flex ms-auto">
							{queue?.documentIds?.length > 0 && <> <span id="fileToggleElem">
								<FontAwesomeIcon icon={faDownload} data-tip={"Download Original"} onClick={() => { _downloadFile(queue?._id) }} />
							</span> <ReactTooltip /> </>}
							{(queue?.status < 5 || queue?.ml_response_error) && queue?.deleted != true ? <><span id="deleteToggleElem">
								<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faTrash} data-tip={'Remove from queue'} onClick={() => _deleteQueue(queue?._id)} />
							</span> <ReactTooltip /> </> : ''}
							<span id="fileToggleElem">
								<FontAwesomeIcon icon={faFile} data-tip={'Total Files : ' + (queue?.files || 'counting')} />

							</span>
							<span id="FolderToggleElem">
								<FontAwesomeIcon icon={faFolder} data-tip={'Total Packets : ' + (queue?.process_packets || 'counting')} />
							</span>
							{((queue?.processed == 80 || queue.processed == 60) && timeDifference >= 1000*60*60) || queue?.ml_response_error ? <><span id="viewToggleElem">
								<FontAwesomeIcon style={{ cursor: "pointer" }} icon={faEye} data-tip={'View'} onClick={() => _viewDocuments(queue?._id)} />
							</span> <ReactTooltip /> </> : ''}
							<span id="FolderToggleElem">
								<FontAwesomeIcon icon={faList} data-tip={'Audit logs'} onClick={() => _viewDocumentLogs(queue?.documentIds[0]?._id)}/>
							</span>
							<ReactTooltip />
						</div>
					</div>
					<div className="inner-blc">
						
						<div className="progress-blc d-flex">
							
							<div className="left-col flex-fill">
								<div className="row-cell">
									<Progress
										className="flex-fill"
										color={queue?.ml_response_error ? 'danger' : 'secondary'}
										value={queue?.processed}
										style={{ backgroundColor: queueId === queue?._id ? "#a7b1b8" : '' }}
									>
									</Progress>
								</div>
								<div className="file-status-blc d-flex align-items-center">
									<span className="file-size">{queue?.size}</span>
									
									<div className={`file-status ms-auto ${queue.ml_response_error ? 'error-color' : ''}`}>
										{queue?.ml_response_error && queue?.documentIds && queue?.documentIds.length ? 
											`Error ${queue?.documentIds[0]?.upload_attempts && queue?.documentIds[0]?.upload_attempts.length > 0 ? ` - Tried Again ${queue?.documentIds[0]?.upload_attempts.length} Attempts` : ''}` 
											: processes[queue?.status]}
										</div>

								</div>
							</div>
							<span className="progress-value">{queue?.processed}<span>%</span></span>
						</div>
					</div>
				</li>
			</ul>
		</>
	);
};

export default UploadedFileItem;
